const STATE_GRID_LAYOUT = [
  { key: 'AK', x: 0, y: 0 },
  { key: 'ME', x: 10, y: 0 },
  { key: 'VT', x: 9, y: 1 },
  { key: 'NH', x: 10, y: 1 },
  { key: 'WA', x: 0, y: 2 },
  { key: 'ID', x: 1, y: 2 },
  { key: 'MT', x: 2, y: 2 },
  { key: 'ND', x: 3, y: 2 },
  { key: 'MN', x: 4, y: 2 },
  { key: 'IL', x: 5, y: 2 },
  { key: 'WI', x: 6, y: 2 },
  { key: 'MI', x: 7, y: 2 },
  { key: 'NY', x: 8, y: 2 },
  { key: 'MA', x: 9, y: 2 },
  { key: 'RI', x: 10, y: 2 },
  { key: 'OR', x: 0, y: 3 },
  { key: 'NV', x: 1, y: 3 },
  { key: 'WY', x: 2, y: 3 },
  { key: 'SD', x: 3, y: 3 },
  { key: 'IA', x: 4, y: 3 },
  { key: 'IN', x: 5, y: 3 },
  { key: 'OH', x: 6, y: 3 },
  { key: 'PA', x: 7, y: 3 },
  { key: 'NJ', x: 8, y: 3 },
  { key: 'CT', x: 9, y: 3 },
  { key: 'CA', x: 0, y: 4 },
  { key: 'UT', x: 1, y: 4 },
  { key: 'CO', x: 2, y: 4 },
  { key: 'NE', x: 3, y: 4 },
  { key: 'MO', x: 4, y: 4 },
  { key: 'KY', x: 5, y: 4 },
  { key: 'WV', x: 6, y: 4 },
  { key: 'VA', x: 7, y: 4 },
  { key: 'MD', x: 8, y: 4 },
  { key: 'DE', x: 9, y: 4 },
  { key: 'AZ', x: 1, y: 5 },
  { key: 'NM', x: 2, y: 5 },
  { key: 'KS', x: 3, y: 5 },
  { key: 'AR', x: 4, y: 5 },
  { key: 'TN', x: 5, y: 5 },
  { key: 'NC', x: 6, y: 5 },
  { key: 'SC', x: 7, y: 5 },
  { key: 'DC', x: 8, y: 5 },
  { key: 'OK', x: 3, y: 6 },
  { key: 'LA', x: 4, y: 6 },
  { key: 'MS', x: 5, y: 6 },
  { key: 'AL', x: 6, y: 6 },
  { key: 'GA', x: 7, y: 6 },
  { key: 'HI', x: 0, y: 7 },
  { key: 'TX', x: 3, y: 7 },
  { key: 'FL', x: 8, y: 7 },
];


export default function config(props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: isMobile ? 10 : 20,
    right: 30,
    bottom: 10,
    left: isMobile ? 40 : 30,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;

  return {
    ...props,
    data: STATE_GRID_LAYOUT,
    gridWidth: 9, // Adjust if necessary based on max x values
    gridHeight: 9, // Adjust if necessary based on max y values
    margins,
    width,
    height,
  };
}
